/**
 * Configuration for a single lycra color used in competitions.
 * Defines the color, its display name, and sort order for result display.
 */
export interface LycraColorConfig {
  color: string;      // Hex color code (e.g., "#FF0000")
  name: string;       // Display name (e.g., "Red")
  sortOrder: number;  // Sort priority (1 = highest)
}

/**
 * Default lycra color configuration.
 * This matches the original hardcoded values from the backend.
 */
export const DEFAULT_LYCRA_COLORS: LycraColorConfig[] = [
  { color: "#FF0000", name: "Red", sortOrder: 1 },
  { color: "#FFFFFF", name: "White", sortOrder: 2 },
  { color: "#0000FF", name: "Blue", sortOrder: 3 },
  { color: "#48BCE4", name: "Light Blue", sortOrder: 4 },
  { color: "#F9D900", name: "Yellow", sortOrder: 5 },
  { color: "#1B1B1B", name: "Black", sortOrder: 6 },
];
